import { findLastIndex } from 'lodash';
import styled from 'styled-components';
import Colors from '../../../../enums/Colors';
import { MobileMaxWidth } from '../../../../constants/Dimensions';
import { PrimaryButton } from 'components/UI/Buttons';

export const ContactContainerStyle = styled.div<{ isLight?: boolean; bottomFixedMenu?: boolean }>`
    background-color: ${({ isLight }) => (isLight ? Colors.White : Colors.Blue)};
    display: flex;
    flex-direction: column;
    padding-right: 3vw;
    padding-left: 3vw;
    padding-bottom: ${({ bottomFixedMenu }) => (bottomFixedMenu ? '110px' : '17.5px')};
`;

export const Contents = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 16px;
    margin-top: 60px;
    margin-bottom: 22px;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        flex-direction: column;
        gap: 0vw;
    }
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        min-height: unset;
    }
`;

export const ContentItemsContainer = styled.div`
    font-family: 'Barlow';
    font-style: normal;
    font-weight: 300;
    line-height: 120%;
    letter-spacing: 0.01em;
`;

interface IDefaultText {
    fontSize: string;
    color: Colors;
}

export const DefaultText = styled.p<IDefaultText>`
    color: ${props => props.color};
    font-size: ${props => props.fontSize};
`;

export const Title = styled(DefaultText).attrs({
    fontSize: '24px',
})`
    font-weight: 700;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        font-size: 18px;
        line-height: 22px;
    }
`;

export const ItemText = styled(DefaultText).attrs({
    fontSize: '16px',
})`
    font-weight: 300;
    margin-left: 20px;
    white-space: pre-wrap;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        font-size: 16px;
        line-height: 19px;
    }
`;

export const ContactItem = styled.div<{ isLight?: boolean }>`
    color: ${({ isLight }) => (isLight ? Colors.Blue : Colors.White)};
    display: flex;
    align-items: center;

    > p {
        margin-left: 23px;
    }
`;

export const Img = styled.img`
    height: 70%;
    width: 70%;
`;

export const HumaneLogoStyle = styled.img`
    height: 111px;
    width: 618px;

    @media only screen and (min-width: 900px) and (max-width: 1250px) {
        width: 421px;
    }

    @media only screen and (min-width: ${MobileMaxWidth}px) and (max-width: 900px) {
        width: 326px;
    }

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        width: 321px;
    }

    @media only screen and (max-width: 320px) {
        width: 250px;
    }
`;

export const Link = styled.a<{ isLight?: boolean }>`
    margin-right: 50px;
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;
    color: ${({ isLight }) => (isLight ? Colors.Blue : Colors.White)};
    text-decoration: underline;
    &:hover {
        color: white;
    }

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        margin-right: unset;
    }
`;

export const LinkFooter = styled.a<{ isLight?: boolean }>`
    margin-right: 50px;
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;
    color: ${({ isLight }) => (isLight ? Colors.Blue : Colors.White)};
    text-decoration: underline;
    &:hover {
        color: white;
    }

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        margin-right: unset;
        white-space: nowrap;
        font-size: 10px;
        > p {
            white-space: nowrap;
            font-size: 10px;
        }
    }
`;

export const SocialIcon = styled(Link)`
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-right: 20px;
    margin-bottom: 17px;
    text-decoration: none !important;

    > p {
        margin-left: 23px;
    }
`;

export const SocialIcon2 = styled(Link)<{isLight?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid #506d97;
    height: 45px;
    width: 45px;
    border-radius: 100%;
    margin-right: 25px;
`;

export const AcessButton = styled(PrimaryButton)`
    width: 200px;
    height: 65px;
    font-size: 18px;
    line-height: 20px;
    border-radius: 72px;
    border: none;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        height: 57px;
        letter-spacing: 0.3px;
        display: flex;
        border-radius: 50px;
        font-size: 14px;
        line-height: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0px;
        width: 213px;

        @media only screen and (max-width: 320px) {
            width: 220px;
        }
    }
`;

export const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10vw;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        align-items: center;
        flex-direction: column;
        gap: 4vw;
    }
`;

export const FlexContainerFooter = styled.div`
    display: flex;
    justify-content: center;
`;

export const FlexContainerSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: ${MobileMaxWidth}px) {
        margin-top: 32px;
        flex-direction: column-reverse;
        align-items: center;
    }
`;

export const LogRodapeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    @media only screen and (max-width: ${MobileMaxWidth}px) {
        align-items: center;
    }
`;

export const FlexContainerColumnSpace = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: start;
    height: 100%;
    width: 100%;

    @media screen and (max-width: 700px) {
        flex-direction: column;
        align-items: center;
        margin-top: 22px;
        justify-content: center;
        gap: 22px;
    }
`;

export const TextRede = styled.p`
    //styleName: Body;
    font-family: 'Poppins';
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    margin-bottom: 12px;
    color: ${Colors.White};
`;

export const FlexAccountsRedes = styled.div`
    display: flex;
`;

export const LinkContainer = styled.a``;
